import styled from 'styled-components';
import colors from '_colors.module.scss';

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;
